import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'
import { BodyText as Text } from 'ui/styles/utils'
import Links from 'ui/components/generic/Links'
import LocalizedString from '../../generic/LocalizedString'
import withTranslations from 'containers/withTranslations'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'




class BodyText extends Component {

  constructor(props) {
    super(props)
    this.state = {
      toggled: this.props.truncate,
    }
  }

  readMore = () => {
    this.setState({ toggled: !this.state.toggled })

  }

  render() {
    const { body, buttons, lines, truncate, bgcolor } = this.props

    const { toggled } = this.state

    const show = toggled && truncate

    return (
      <Wrapper bgcolor={bgcolor} buttons={buttons}>
        <HeroWrapper fluid>
          <Row>
            <Col>
              <Article lines={show ? lines : undefined} dangerouslySetInnerHTML={{ __html: body }} />
              {this.props.truncate &&
                <ButtonContainer>
                  <ReadMore color="secondary" toggled={!toggled} onClick={this.readMore}>{show === true ? <LocalizedString group="genericLabels" string="readMore" /> : <LocalizedString group="genericLabels" string="readLess" />}</ReadMore>
                </ButtonContainer>
              }
              <Links color="primary" links={buttons} />
            </Col>
          </Row>
        </HeroWrapper>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
  padding-top: ${props => props.bgcolor === 'grey' ? '1em' : '0'};
  padding-bottom: ${props => props.buttons.length > 0 ? '1em' : '0'};
`

const Article = styled(Text)`
overflow: hidden;
display: -webkit-box;
-webkit-line-clamp: ${props => props.lines};
-webkit-box-orient: vertical;
-webkit-mask-image: linear-gradient(180deg, black ${props => props.lines !== undefined ? '' : '100%'}, transparent);
transition: all 400ms;

ul {
  padding: 2rem !important;
}

ol {
  padding: 2rem !important;
}



`

const ButtonContainer = styled.div`
display: flex;
justify-content: center;
`
const HeroWrapper = styled(Container)`
                    padding: 0 20px;
                    ${media.lg`
                    padding: 0 20%;
                    `}
                    `

const ReadMore = styled.button`
height: 40px;
min-width: 150px;
display: inline-flex;
align-items: center;
justify-content: center;
padding: 0 20px;
border-radius: 20px;
border: ${props => props.toggled ? "solid 1px rgba(21, 21, 21, 0.80)" : "none"};
background-color:  ${props => props.toggled ? "transparent" : " rgba(21, 21, 21, 0.80)"}; ;
color: ${props => props.toggled ? "rgba(21, 21, 21, 0.80)" : "white"};

text-transform: uppercase;
font-size: 12px;
font-family: ${props => props.theme.bodyFont};
font-weight: 500;
margin-top: 20px;

transition: all 400ms;

& + a {
  margin-left: 10px !important;
}

&:hover {
  background-color: rgba(100, 100, 100, 0.68);
  color: #fff;
}
`


export default compose(
  withRouter,
  withTranslations()
)(BodyText)



// WEBPACK FOOTER //
// ./src/ui/components/modules/BodyText/index.js